import { CONSTANTS } from "@/helpers/constants";

export const state = {
    profile: null,
    changeProfile: false,
    phoneNumberIsMetfone: false,
    defaultParam: null
}

export const mutations = {
    SET_CURRENT_PROFILE(state, newValue) {
        state.profile = newValue
    },
    SET_CHANGE_PROFILE(state, newValue) {
        state.changeProfile = newValue;
    },
    SET_IS_METFONE_PHONE_NUMBER(state, phoneNumber) {
        if (phoneNumber) {
            let phone = phoneNumber;
            let tempPhone = phone.replace(/\D/g, "");
            let regex = /(00855|855|0|)(31|60|66|67|68|71|88|90|97|236|246|256|266|326|336|346|356|366|426|436|446|526|536|546|556|626|636|646|656|726|736|746|756)\d{6,7}/
            let test = regex.test(tempPhone);
            state.phoneNumberIsMetfone = test;
        }
        else
            state.phoneNumberIsMetfone = false;
    },
    SET_DEFAULT_PARAM(state, value) {
        state.defaultParam = value;
    }
}

export const getters = {
    getProfile(state) {
        return state.profile
    },
    getDefaultParam(state) {
        return state.defaultParam;
    }
}

export const actions = {
    async setProfile({ commit }, value) {
        commit("SET_CURRENT_PROFILE", value)
    },
    async setChangeProfile({ commit }) {
        commit("SET_CHANGE_PROFILE", !state.changeProfile)
    },
    async isMetfoneNumber({ commit }, value) {
        commit("SET_IS_METFONE_PHONE_NUMBER", value);
    },
    async setDefaultParam({ commit }) {
        if (state.profile) {
            const profile = state.profile;
            
            let langTemp = profile.lang;
            let findLang = CONSTANTS.Locales.find(x => x.code == langTemp);
            let lang = findLang ? findLang.name : "en_US";


            let phone = profile.phone.replace(/\D/g, "");
            let token = CONSTANTS.TOKEN;
            commit("SET_DEFAULT_PARAM", {
              locale: profile.lang,
              msisdn: phone,
              partnerAccount: profile.id,
              token: token,
              env: "",
              // env: "PRE"
            });
        } else {
            commit("SET_DEFAULT_PARAM", {
                locale: "en_US",
                msisdn: "855312594732",
                partnerAccount: "855312594732",
                token: CONSTANTS.TOKEN
            });
        }
    }
}

